import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

export const Paragraph = styled.p`
  margin-top: ${({ theme }) => theme.spacing.two_2};
  margin-bottom: ${({ theme }) => theme.spacing.one};

  color: ${({ theme }) => theme.colors.black_80};

  font-size: ${({ theme }) => theme.fontSize.xs};
`;

export const BackToLoginLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  display: block;
  text-align: center;
`;
